import { useEffect, useMemo, useRef, useState } from 'react'
import { useSetState } from 'ahooks'
import { useParams } from 'react-router-dom'
import {
  SDrawerOrModal,
  SFuncModal,
  SFuncModalFormRef,
  SLowcodeList,
  SMessage,
  STableActions, STags,
} from 'shj-components'
import { getConfig } from './config.tsx'
import { AddOrEditCategory } from './addOrEdit/category.tsx'
import { AddOrEditProject } from './addOrEdit/project.tsx'
import { AddOrEditGeneral } from './addOrEdit/general.tsx'
import { AddOrEditChild } from './addOrEdit/childItem.tsx'
import { AddOrEditProduct } from './addOrEdit/product.tsx'
import ExtraModal from './addOrEdit/extra.tsx'
import StandardDetail from '@/pages/baseProduct/generalManage/addOrEdit/index.tsx'
import { batchIdGenerate, idGenerate, packModelEditImportExcel, ReadExcel } from '@/services/product.ts'
import { httpOrgList } from '@/services/homeService.ts'
import { getChildrenDicts } from '@/services'
import { onMatchFormSearch } from '@/pages/customerConfig/customerLabel/util.ts'
import styles from '@/pages/baseProduct/packageTemplate/addOrEdit/index.module.less'
import {
  findAndModifyTreeNode,
  traverseTree,
  treeToArray,
} from '@/pages/baseProduct/packageTemplate/addOrEdit/steps/utils.ts'
import { Button, Form, Input, message, Upload } from 'antd'
import { cloneDeep, isArray } from 'lodash-es'
import UrlConfig from '@/api/UrlConfigs.ts'
import { fileDownload } from '@/utils/download.ts'
import { DownloadOutlined, UploadOutlined } from '@ant-design/icons'
import _ from 'lodash'
import record from "@/pages/serviceConfig/insureManagement/insureAccount/record";

const StepPackageProduct = props => {
  const { fetchApi, baseInfo } = props
  const { id } = useParams()
  const importRef = useRef<any>()
  const listRef = useRef<any>()
  const dataRef = useRef([])
  const editRef = useRef<SFuncModalFormRef>({ onFinish: undefined })
  const filterDataRef = useRef<any>([])

  const config = getConfig(id)
  const [state, setState] = useSetState<any>({
    visible: false,
    type: 'PRD_CATE',
    record: {},
    companyList: [],
    spaceList: [],
    dataSource: [],
    initFetch: false,
    searchValue: '',
    parentRecord: {},
    submitLoading: false,
    selectedRowKeys: [],
  })
  const [btnLoading, setBtnLoading] = useState<any>(false)
  const [btnImportLoading, setBtnImportLoading] = useState<any>(false)
  const [btnDownloadLoading, setBtnDownloadLoading] = useState<any>(false)
  const [form] = Form.useForm()
  const [extraConfigChooseBustype, setExtraConfigChooseBustype] = useState('')
  const [editExtraConfig, setEditExtraConfig] = useState<Array<any>>([])
  const [editExtraConfigRecord, setEditExtraConfigRecord] = useState({})
  const [openExtraConfigModal, setOpenExtraConfigModal] = useState(false)

  useEffect(() => {
    getOptions()
    // setState({ dataSource: id ? baseInfo.treeNodes || [] : state.dataSource })
  }, [baseInfo])

  useEffect(() => {
    setState({ dataSource: id ? baseInfo.treeNodes || [] : state.dataSource })
  }, [baseInfo.treeNodes])

  useEffect(() => {
    const keys = listRef.current?.getSelectedRowKeys?.()?.[0] || []
    listRef.current?.setSelectedRowKeys?.(keys.filter(key => !state.notKeys.includes(key)))
  }, [state.notKeys]);

  useEffect(() => {
    const showNameKey = listRef.current?.getSearch()?.getFieldValue('showNameKey')
    // 处理一下 没有子数据但是有展开符号
    const newDataSource = cloneDeep(state.dataSource)
    traverseTree(newDataSource, node => {
      if (node.children?.length === 0) {
        node.children = null
      }
    })
    if (showNameKey) {
      // 更新编辑过后的值放到过滤数组中
      filterDataRef.current = filterTreeByKeyword(newDataSource, showNameKey)
      listRef.current?.updateDataSource(filterDataRef.current, filterDataRef.current?.length)
    } else {
      dataRef.current = state.dataSource
      listRef.current?.updateDataSource(newDataSource, newDataSource?.length)
    }

  }, [state.dataSource])

  useEffect(() => {
    if (!state.dataSource?.length) {
      return
    }
    const newTreeNodes = [...state.dataSource]
    findAndModifyTreeNode(newTreeNodes, editExtraConfigRecord.id, node => {
      // 修改父级 - parentNode为修改前父级对象
      if (node) {
        node.customizes = editExtraConfig
      }
    })
    setState({ dataSource: newTreeNodes })
  }, [editExtraConfig])

  const getOptions = async () => {
    const space = await getChildrenDicts(['spaceKey'])
    const companyList = await httpOrgList()
    setState({ companyList, spaceList: space[0]?.children })
  }

  const newSpaceList = useMemo(() => {
    const hasSpaceKeys = []
    traverseTree(state.dataSource, node => {
      const isExpired = node?.isExpire || node?.expirationTime;
      if (!isExpired) hasSpaceKeys.push(node?.spaceTag || [])
    })
    return state.spaceList?.map(item => ({ ...item, disabled: hasSpaceKeys.includes(item.priKey) }))
  }, [state.dataSource, state.spaceList])

  const fetchList = ({ query }) => {
    let showNameKey = listRef.current?.getSearch()?.getFieldValue('showNameKey')
    return new Promise((resolve, reject) => {
      if (!id && !state.dataSource.length) {
        listRef.current?.updateDataSource([])
        resolve([])
      } else {
        if (showNameKey) {
          filterDataRef.current = filterTreeByKeyword(state.dataSource, showNameKey)
          resolve([...filterDataRef.current])
          listRef.current?.updateDataSource(filterDataRef.current, filterDataRef.current?.length)
        } else {
          resolve([...state.dataSource])
          listRef.current?.updateDataSource(state.dataSource, state.dataSource?.length)
          // setState({ dataSource: baseInfo.treeNodes })
        }
      }
    })
  }
  const filterTreeByKeyword = (treeData, keyword) => {
    const result: any = []
    const newArray = _.cloneDeep(treeToArray(treeData))
    newArray.forEach((item: any) => {
      if (item.dtlName.toLowerCase().includes(keyword.toLowerCase())) {
        item.children = null
        result.push(item)
      }
    })
    return result
  }
  const onAddOrEdit = ({
    record = {},
    type = 'PRD_CATE',
    isAddChild = false,
  }: Record<string, any>) => {
    setState({
      visible: true,
      type,
      record: isAddChild ? { parentId: record.id, level: record.level + 1 } : { ...record },
      parentRecord: isAddChild ? { ...record } : {},
    })
  }

  const onChildItemDetail = record => {
    if (!id) {
      localStorage.setItem('packTreeData', JSON.stringify(listRef.current?.getDataSource()))
    }
    window.open('/config/baseProduct/subItemList/detailList/' + record.busId)
  }

  const onClose = () => {
    setState({ visible: false, record: {}, submitLoading: false })
  }

  const onSubmit = () => {
    if (state.record?.isExpire || state.record?.expirationTime) {
      return message.error('失效数据不可进行编辑！')
    }
    editRef.current.onFinish?.().then((res: any) => {
      console.log(res, 'res')
      console.log(res, 'res')
      let dataSource = cloneDeep(state.dataSource || listRef.current?.getDataSource() || [])
      try {
        if (!res.id) {
          idGenerate({})
            .then(newId => {
              const res_ = { ...res, id: newId }
              if (res.parentId && res.parentId != '0') {
                // 有父级的情况
                findAndModifyTreeNode(dataSource, res.parentId, node => {
                  if (node) {
                    node.children
                      ? !checkSameId(node.children, res_) && node.children.unshift(res_)
                      : (node.children = [res_])
                  }
                })
              } else {
                // 添加到根节点
                !checkSameId(dataSource, res_) && dataSource.unshift({ ...res_, parentId: '0' })
              }
              setState({ dataSource: [...dataSource] })
              onClose()
            })
            .finally(() => setState({ btnLoading: false }))
        } else {
          if (res.parentId && res.parentId !== '0') {
            // 编辑二级节点
            let checkFlag = false
            if (res.parentId !== res.oldParentId) {
              // 修改父级 - parentNode为修改后父级对象 bn
              console.log(res, 'res')
              findAndModifyTreeNode(dataSource, res.parentId, parentNode => {
                if (parentNode) {
                  const keys = Object.keys(res)
                  const allKeys = keys.includes('children') ? [...keys] : [...keys, 'children']
                  try {
                    allKeys.forEach(key => {
                      if (key === 'children') {
                        if (parentNode[key]) {
                          checkFlag = checkSameId(parentNode['children'], res)
                          if (checkFlag) {
                            // 取消更改 并且复原父级id
                            res.parentId = res.oldParentId
                            throw new Error('重复')
                          } else {
                            parentNode[key] =
                              parentNode[key].length > 0 ? [...parentNode[key], res] : [res]
                          }
                        } else {
                          parentNode[key] = [res]
                        }
                      }
                    })
                  } catch (error) {
                    console.log(error, 'error')
                  }
                }
              })
              // 修改原父级 - parentNode为修改前父级对象
              if (res.oldParentId == '0') {
                dataSource = dataSource.filter(item => item.id !== res.id)
              } else {
                findAndModifyTreeNode(dataSource, res.oldParentId, parentNode => {
                  if (parentNode && !checkFlag) {
                    const keys = Object.keys(res)
                    const allKeys = [...keys, 'children']
                    allKeys.forEach(key => {
                      if (key === 'children') {
                        if (parentNode[key]) {
                          parentNode[key] =
                            parentNode[key].length > 0
                              ? parentNode[key].filter(item => item.id != res.id)
                              : []
                        }
                      }
                    })
                  }
                })
              }
            }
            findAndModifyTreeNode(dataSource, res.id, node => {
              if (node) {
                const keys = Object.keys(res)
                keys.forEach(key => {
                  node[key] = [
                    'children',
                    'createdBy',
                    'createdByName',
                    'createdTime',
                    'idPath',
                  ].includes(key)
                    ? node[key]
                    : res[key]
                })
              }
            })
            console.log('dataSource--->', dataSource)
            setState({ dataSource: [...dataSource] })
          } else {
            // 编辑数据到根节点也要验重
            const data = dataSource.filter(item => item.id !== res.id)
            const currentIndex = dataSource.findIndex(item => item.id === res.id)
            checkSameId(data, res)
            // 清除原数据
            findAndModifyTreeNode(dataSource, res.oldParentId, parentNode => {
              if (parentNode) {
                const keys = Object.keys(res)
                const allKeys = [...keys, 'children']
                allKeys.forEach(key => {
                  if (key === 'children') {
                    if (parentNode[key]) {
                      parentNode[key] =
                        parentNode[key].length > 0
                          ? parentNode[key].filter(item => item.id != res.id)
                          : []
                    }
                  }
                })
              }
            })
            if (res.parentId == '0' || !res.parentId) {
              // 恢复根节点子数据
              res.children = dataSource.find((el: any) => el.id === res.id).children
            }
            const newData = [...data];
            newData.splice(currentIndex, 0,  {
              ...res,
              children: res.children,
              idPath: res.idPath,
              createdBy: res.createdBy,
              createdByName: res.createdByName,
              createdTime: res.createdTime,
            })
            console.log(newData, currentIndex)
            // const newData = [
            //   ...data,
            //   {
            //     ...res,
            //     children: res.children,
            //     idPath: res.idPath,
            //     createdBy: res.createdBy,
            //     createdByName: res.createdByName,
            //     createdTime: res.createdTime,
            //   },
            // ]
            setState({ dataSource: newData })
          }
          onClose()
          setState({ btnLoading: false })
        }
      } catch (error) {
        console.log(error)
      }
    })
  }
  /**
   * 校验当前空间下是否存在相同节点
   * @param upSpaceList 上级空间列表
   * @param node 当前节点
   */
  const checkSameId = (upSpaceList, node) => {
    const ableList = upSpaceList.filter(item => !(item.isExpire || item.expirationTime))
    console.log('upSpaceList--->', upSpaceList, ableList, node)
    let flag = ableList.some((item: any) => {
      if (
        node.busType === 'PRD_CATE' ||
        node.busType === 'PRD_PROJECT' ||
        node.busType === 'PRD_SUB_ITEM'
      ) {
        return item.dtlName === node.dtlName
      } else {
        return item.busId === node.busId
      }
    })
    if (flag) {
      message.error('当前空间下已存在相同数据')
      setState({ btnLoading: false, submitLoading: false })
      throw new Error('当前空间下已存在相同数据')
    }
    return flag
  }
  const onDel = (record: any) => {
    SMessage.confirm({
      onOk: () => {
        let newTreeNodes = [...state.dataSource]
        console.log(record, state.dataSource)
        if (!record.parentId || record.parentId == '0') {
          newTreeNodes = newTreeNodes.filter(item => item.id != record.id)
        } else {
          let parentId = record.parentId
          findAndModifyTreeNode(newTreeNodes, parentId, parentNode => {
            // 修改父级 - parentNode为修改前父级对象
            if (parentNode) {
              const keys = Object.keys(record)
              const allKeys = [...keys, 'children']
              allKeys.forEach(key => {
                if (key === 'children') {
                  if (parentNode[key]) {
                    parentNode[key] =
                      parentNode[key].length > 0
                        ? parentNode[key].filter(item => item.id != record.id)
                        : []
                  }
                }
              })
            }
          })
        }
        setState({ dataSource: newTreeNodes })
      },
    })
  }

  // 跳转标配页面
  const clickToStandardPage = record => {
    console.log(record)
    // 手动添加
    if (record.object?.sonChooseType === 'GEN_STANDARD') {
      window.open(
        `/config/baseProduct/generalManage/standard-feature/${record.object?.id}?readOnly=true&&itemName=${record.dtlName}&&specialCode=${record.object?.specialCode}`
      )
    } else {
      // 规则配置
      onAddOrEdit({ type: 'standard', isStandDrawer: true, record: record })
    }
  }
  const copyItem = record => {
    form.setFieldsValue({ dtlName: record.dtlName })
    const dataSource = state.dataSource || listRef.current?.getDataSource() || []
    const dialog = SFuncModal({
      title: '复制',
      content: (
        <Form form={form}>
          <Form.Item
            label={'新对象名称'}
            name="dtlName"
            required={true}
            rules={[{ required: true, message: '名称不能为空' }]}
          >
            <Input placeholder={`请输入新对象名称`} />
          </Form.Item>
        </Form>
      ),
      onOk: () => {
        function treeToList(nodes: any[]): any[] {
          const list: any[] = []
          nodes.forEach(node => {
            list.push(node)
            if (node.children) {
              list.push(...treeToList(node.children))
            }
          })
          return list
        }
        form.validateFields().then((values: Record<string, string>) => {
          console.log('oldData', record)
          const newData = JSON.parse(JSON.stringify(record))
          traverseTree([newData], (node) =>  {
          // 新对象及子级默认有效
            node.isExpire = false;
            node.expirationTime = null;
          })
          newData.spaceTag = undefined // 不复制空间标签
          const nodes = treeToList([newData])
          batchIdGenerate(nodes.length).then(newIds => {
            nodes.forEach((node, index) => {
              const newId = newIds[index]
              node.id = newId
              if (node.children) {
                node.children.forEach(element => {
                  element.parentId = newId
                })
              }
            })
            newData.dtlName = values.dtlName

            if (newData.parentId && newData.parentId != '0') {
              // 有父级的情况
              findAndModifyTreeNode(dataSource, newData.parentId, node => {
                if (node.children) {
                  !checkSameId(node.children, newData) && node.children.unshift(newData)
                }
              })
            } else {
              // 添加到根节点
              !checkSameId(dataSource, newData) && dataSource.unshift({ ...newData, parentId: '0' })
            }
            console.log(dataSource)
            setState({ dataSource: [...dataSource] })
            dialog.destroy()
          })
        })
      },
    })
  }
  const onDownload = () => {
    setBtnDownloadLoading(true)
    onExportOrDownload(id ? UrlConfig.PlusProductWeb.PackModelEditDownloadExcel : UrlConfig.PlusProductWeb.BuildExcel)
  }
  const onExport = (data?: any) => {
    setBtnLoading(true)
    const newData = id ? filterTreeByStatus(data) : data
    onExportOrDownload(UrlConfig.PlusProductWeb.BuildExcel, newData)
  }
  // 下载导入模板 导出
  const onExportOrDownload = (downloadExcel, data?: any) => {
    fileDownload(downloadExcel, {
      method: 'POST',
      data: data || [],
      error: false,
    })
      .then(() => {
        setBtnLoading(false)
        setBtnDownloadLoading(false)
      })
      .catch(async(err) => {
        if (err instanceof Blob || Object.prototype.toString.call(err) === '[object Blob]') {
          try {
            const text = await err.text();
            const jsonData = JSON.parse(text);
            message.error(jsonData.message);
          } catch (error) {
            return err;
          }
        }
        setBtnLoading(false)
        setBtnDownloadLoading(false)
      })
  }

  // 导入
  const clickToImport = () => {
    importRef.current = SMessage.confirm({
      okText: '继续',
      cancelText: '取消',
      content: '每次导入将清空现有配置，新增导入数据，是否继续？',
      title: null,
      footer: () => {
        return (
          <>
            <Button onClick={() => importRef.current?.destroy()} style={{ marginRight: 10 }}>
              取消
            </Button>
            <Upload listType="text" customRequest={onImport} itemRender={() => null}>
              <Button type="primary">继续</Button>
            </Upload>
          </>
        )
      },
      onOk: () => {},
      onCancel: () => {
        importRef.current?.destroy()
      },
    })
  }
  // 编辑导入
  const onEditImport = () => {
    importRef.current = SMessage.confirm({
      content: '当前编辑导入，只能在已有空间下导入预置产品SKU！',
      title: null,
      footer: () => {
        return (
          <>
            <Button onClick={() => importRef.current?.destroy()} style={{ marginRight: 10 }}>
              取消
            </Button>
            <Upload listType="text" customRequest={onImport} itemRender={() => null}>
              <Button type="primary">确认</Button>
            </Upload>
          </>
        )
      },
      onOk: () => {},
      onCancel: () => {
        importRef.current?.destroy()
      },
    })
  }

  const onChangeStatus = ({selectedRows, selectedRowKeys}) => {
    console.log(selectedRowKeys, selectedRows)
    // const isPass = selectedRows?.every(item => item.busType === 'PRD_PROJECT' || item.busType === 'PRD_GEN_ITEM')
    // if (!isPass) {
      SMessage.confirm({
        title: '确认失效该配置数据？',
        content: <div style={{color: 'red'}}>失效后，新增报价，失效数据不再生成；若失效数据关联特定项选材的费用，请在产品管理中修改“勾选特定项”</div>,
        onOk: () => {
          const updateTree = updateTreeNodesByIds(state.dataSource, selectedRowKeys, 'isExpire')
          setState({ dataSource: updateTree })
          listRef.current.updateDataSource(updateTree)
          listRef.current.clearSelectedRowKeys()
          setState({selectedRowKeys: []})
        },
      })
    // } else {
    //   message.error('只有通项或产品才能进行失效！', 3)
    // }
  }

  const updateTreeNodesByIds = (tree, ids, key) => {
    if (!tree || !Array.isArray(tree)) return [];

    const newTree = JSON.parse(JSON.stringify(tree));
    const idSet = new Set(ids);

    const stack = [...newTree];

    while (stack.length) {
      const node = stack.pop();

      if (idSet.has(node.id)) {
        node[key] = true;
      }

      if (node.children) {
        stack.push(...node.children);
      }
    }

    return newTree;
  }

  const filterTreeByStatus = (tree) => {
    if (!tree || !Array.isArray(tree)) return [];

    return tree.filter(node => {
      if (node.isExpire === true || node.expirationTime) return false;

      if (node.children) {
        node.children = filterTreeByStatus(node.children);
      }

      return true;
    });
  }

  const handleOpenExtraConfigModal = (record: any, busType: any) => {
    // 要把通项本身配置带进去，同时记录原有数据
    setEditExtraConfigRecord(record)
    setEditExtraConfig(record.customizes || [])
    setOpenExtraConfigModal(true)
    setExtraConfigChooseBustype(busType)
  }

  const onImport = (upload: any) => {
    setBtnImportLoading(true)
    const { file, onSuccess, onError } = upload
    const data = new FormData()
    data.append('file', file)
    if (id) data.append('treeNodes', new Blob([JSON.stringify(state.dataSource)], {type: 'application/json'}))
    const importExcel = id ? packModelEditImportExcel : ReadExcel;
    console.log(data, state.dataSource, 'importExcel')
    return importExcel(data)
      .then((res: any) => {
        console.log('res', res)
        if (isArray(res)) {
          setState({ dataSource: res })
          message.success('导入成功')
        } else {
          message.error('导入失败')
        }
        console.log(btnLoading, 'btnLoading1111111')
        setBtnImportLoading(false)
      })
      .catch(() => {
        console.log(btnLoading, 'btnLoading1111111')
        setBtnImportLoading(false)
      })
      .finally(() => {
        importRef.current?.destroy()
      })
  }

  const extensions = {
    request: { fetchList },
    events: {
      // onSearchReset,
      onAddCategory: () => onAddOrEdit({ type: 'PRD_CATE' }),
      onAddProject: () => onAddOrEdit({ type: 'PRD_PROJECT' }),
      onAddGeneral: () => onAddOrEdit({ type: 'PRD_GEN_ITEM' }),
      onAddChild: () => onAddOrEdit({ type: 'PRD_SUB_ITEM' }),
      onChangeStatus,
    },
    scroll: { y: 'calc(100vh - 430px)' },
    selectedRowKeys: state.selectedRowKeys,
    rowSelection: id ? {
      onSelectAll: (selected: boolean, selectedRows: any[]) => {
        const keys = selectedRows.map(item => item.id)
        setState({selectedRowKeys: keys})
      },
      onSelect: (current: any, isChecked: boolean) => {
        // 获取节点及其所有子节点的ID
        const getAllIds = (rows: any[]) => {
          const ids: any[] = [];
          const traverse = (nodes: any[]) => {
            nodes.forEach(node => {
              ids.push(node.id);
              if (node.children?.length) {
                traverse(node.children);
              }
            });
          };
          traverse(rows);
          return ids;
        };

        // 查找指定ID节点的所有父级节点
        const findParentNodes = (targetId: any, treeData: any[]) => {
          const parents: any[] = [];
          const traverse = (nodes: any[], path: any[] = []) => {
            for (const node of nodes) {
              if (node.id === targetId) {
                parents.push(...path);
                return true;
              }
              if (node.children?.length) {
                if (traverse(node.children, [...path, node])) {
                  return true;
                }
              }
            }
            return false;
          };
          traverse(treeData);
          return parents;
        };

        let allIds = [...state.selectedRowKeys];
        if (isChecked) {
          // 选中时，添加当前节点及其所有子节点
          allIds = [...allIds, ...getAllIds([current])];
        } else {
          // 取消选中时，只移除当前节点及其所有子节点
          const idsToRemove = new Set(getAllIds([current]));
          // 获取所有父级节点ID（只移除父级节点，不移除父级节点的其他子节点）
          const parentNodes = findParentNodes(current.id, state.dataSource || []);
          parentNodes.forEach(parentNode => {
            idsToRemove.add(parentNode.id); // 只添加父级节点ID到移除列表
          });
          // 过滤掉需要移除的ID
          allIds = allIds.filter(id => !idsToRemove.has(id));
        }
        setState({ selectedRowKeys: [...new Set(allIds)] });
      },
    } : false,
    status: {
      topLevelIsCate: () =>
        state.dataSource.length && state.dataSource?.[0]?.busType !== 'PRD_CATE',
      topLevelIsProject: () =>
        state.dataSource.length &&
        !state.dataSource?.some(item => ['PRD_PROJECT', 'PRD_SUB_ITEM'].includes(item.busType)),
      topLevelIsGeneral: () =>
        state.dataSource.length && !state.dataSource?.some(item => item.busType === 'PRD_GEN_ITEM'),
    },
    customRender: {
      actionRender(_: null, record_: Record<string, any>): JSX.Element {
        const record = { ...record_, ...record_.dtl, id: record_.id }
        const children = record.children?.length ? record.children : undefined
        const isExpire =  record.isExpire || record.expirationTime
        const showCateBtn =
          record_.busType === 'PRD_CATE' &&
          record.parentId == '0' &&
          (children?.every(item => item.busType === 'PRD_CATE') || !children)
        const showProBtn =
          record_.busType === 'PRD_CATE' &&
          (children?.some(item => ['PRD_SUB_ITEM', 'PRD_PROJECT'].includes(item.busType)) ||
            !children)
        const showGeneralBtn =
          ['PRD_PROJECT'].includes(record_.busType) &&
          (children?.every(
            item => item.busType === 'PRD_GEN_ITEM' || item.busType === 'PRD_PRODUCT'
          ) ||
            !children)
        const showExtraConfig =
          record_.busType === 'PRD_GEN_ITEM' || record_.busType === 'PRD_PRODUCT'
        return (
          <STableActions>
            <STableActions.SActionBtn onClick={() => onAddOrEdit({ record, type: record.busType })}>
              编辑
            </STableActions.SActionBtn>
            {!id ? <STableActions.SActionBtn danger onClick={() => onDel(record)}>
              删除
            </STableActions.SActionBtn> : ''}
            {showCateBtn && !isExpire && (
              <STableActions.SActionBtn
                onClick={() =>
                  onAddOrEdit({
                    type: 'PRD_CATE',
                    record,
                    isAddChild: true,
                  })
                }
              >
                添加分类
              </STableActions.SActionBtn>
            )}
            {showProBtn && !isExpire && (
              <STableActions.SActionBtn
                onClick={() =>
                  onAddOrEdit({
                    type: 'PRD_PROJECT',
                    record,
                    isAddChild: true,
                  })
                }
              >
                添加项目
              </STableActions.SActionBtn>
            )}
            {showProBtn && !isExpire && (
              <STableActions.SActionBtn
                onClick={() =>
                  onAddOrEdit({
                    type: 'PRD_SUB_ITEM',
                    record,
                    isAddChild: true,
                  })
                }
              >
                添加子项
              </STableActions.SActionBtn>
            )}
            {showGeneralBtn && !isExpire && (
              <STableActions.SActionBtn
                onClick={() =>
                  onAddOrEdit({
                    type: 'PRD_GEN_ITEM',
                    record,
                    isAddChild: true,
                  })
                }
              >
                添加通项
              </STableActions.SActionBtn>
            )}
            {record.busType === 'PRD_PROJECT' && !isExpire && (
              <STableActions.SActionBtn
                onClick={() =>
                  onAddOrEdit({
                    type: 'PRD_PRODUCT',
                    record: { parentId: record.id },
                  })
                }
              >
                添加产品
              </STableActions.SActionBtn>
            )}
            {record_.busType === 'PRD_GEN_ITEM' && (
              <STableActions.SActionBtn onClick={() => clickToStandardPage(record)}>
                标配
              </STableActions.SActionBtn>
            )}
            {record_.busType === 'PRD_SUB_ITEM' && (
              <STableActions.SActionBtn onClick={() => onChildItemDetail(record)}>
                子项详情
              </STableActions.SActionBtn>
            )}
            {showExtraConfig ? (
              <STableActions.SActionBtn
                onClick={() => handleOpenExtraConfigModal(record, record_.busType)}
              >
                特殊配置
              </STableActions.SActionBtn>
            ) : null}
            {['PRD_CATE', 'PRD_PROJECT', 'PRD_SUB_ITEM'].includes(record.busType) && (
              <STableActions.SActionBtn onClick={() => copyItem(record)}>
                复制
              </STableActions.SActionBtn>
            )}
          </STableActions>
        )
      },
      companyRender(_, record) {
        return <div>{record.shopList?.map(item => item.companyName).join('、')}</div>
      },
      downloadRender(_, record) {
        if (!id) {
          return (
            <div style={{ display: 'flex' }}>
              <Button style={{ marginRight: '10px' }} onClick={() => onDownload()} loading={btnDownloadLoading}>
                下载导入模板
              </Button>

              <Button onClick={() => clickToImport()} loading={btnImportLoading}>
                批量导入
              </Button>
            </div>
          )
        } else {
          return (
            <div style={{ display: 'flex' }}>
              <Button style={{ marginRight: '10px' }} onClick={() => onDownload()} loading={btnDownloadLoading}>
                导入模板下载
              </Button>
              <Button onClick={() => onEditImport()} loading={btnImportLoading}>
                批量导入
              </Button>
            </div>
          )
        }
      },
      isExpireRender(isExpire, record){
        const v = isExpire || record.expirationTime
        return <STags itemKey='' label={!v ? '有效' : '失效'} fontColor={!v ? '#00A865' : '#EB3723'} bgColor={!v ? '#D7F7EA' : '#FFEAE8'} />
      },
      exportDownloadRender(_, record) {
        const dataIsProject = state.dataSource.every(item => item.busType === 'PRD_PROJECT')
        return (
          <Button
            onClick={() => onExport(state.dataSource)}
            loading={btnLoading}
            disabled={!dataIsProject}
          >
            导出
          </Button>
        )
      },
    },
  }

  const onFinish = (): Promise<any> => {
    return new Promise((resolve, reject) => {
      props.setLoading?.(true)
      console.log(state.dataSource, 'data--submit')
      const data = state.dataSource
      if (data && data.length) {
        resolve({
          treeNodes: data,
        })
      } else {
        resolve({
          treeNodes: []
        })
      }
    })
  }

  if (props.editRef) props.editRef.onFinish = onFinish

  const getTitle = () => {
    let titleBefore = ''
    if (state.type !== 'standard') {
      titleBefore = state.record.id ? '编辑' : '新增'
      props.readOnly && (titleBefore = '查看')
    }
    return titleBefore + modalObj[state.type]?.title
  }

  const modalObj = {
    PRD_CATE: {
      title: '分类',
      component: (
        <AddOrEditCategory
          {...props}
          {...state}
          spaceList={newSpaceList}
          ref={editRef}
          dataSource={state.dataSource}
          setSubmitLoading={(submitLoading: boolean) => setState({ submitLoading })}
          onClose={onClose}
        />
      ),
    },
    PRD_PROJECT: {
      title: '项目',
      component: (
        <AddOrEditProject
          {...props}
          {...state}
          spaceList={newSpaceList}
          ref={editRef}
          dataSource={state.dataSource}
          setSubmitLoading={(submitLoading: boolean) => setState({ submitLoading })}
          onClose={onClose}
        />
      ),
    },
    PRD_GEN_ITEM: {
      title: '通项',
      component: (
        <AddOrEditGeneral
          {...props}
          {...state}
          spaceList={newSpaceList}
          ref={editRef}
          dataSource={state.dataSource}
          setSubmitLoading={(submitLoading: boolean) => setState({ submitLoading })}
          // isSubtract={step1.isSubtract}
          onClose={onClose}
        />
      ),
    },
    PRD_SUB_ITEM: {
      title: '子项',
      component: (
        <AddOrEditChild
          {...props}
          {...state}
          spaceList={newSpaceList}
          ref={editRef}
          dataSource={state.dataSource}
          setSubmitLoading={(submitLoading: boolean) => setState({ submitLoading })}
          onClose={onClose}
        />
      ),
    },
    standard: {
      title: '标配',
      // component: <StandardTable readOnly={true} genItemId={state.record.busId} />,
      component: (
        <StandardDetail
          editRef={editRef.current}
          onCancel={onClose}
          isStand={true}
          fn={listRef.current?.reload}
          readOnly={true}
          setLoading={loading => setState({ loading })}
          record={state.record.object}
        />
      ),
    },
    PRD_PRODUCT: {
      title: '产品',
      component: (
        <AddOrEditProduct
          {...props}
          {...state}
          // options={options}
          setLoading={(btnLoading: boolean) => setState({ btnLoading })}
          ref={editRef}
          fn={listRef.current?.reload}
          onClose={onClose}
        />
      ),
    },
  }

  return (
    <>
      <div className={styles.edit_wrap}>
        <SLowcodeList searchMode={'group'} ref={listRef} config={config} {...extensions} />
        <SDrawerOrModal
          width={600}
          antdProps={{ ...{ [state.type === 'standard'  ? 'footer' : '']: null } }}
          title={getTitle()}
          onCancel={onClose}
          onOk={onSubmit}
          loading={state.submitLoading}
          open={state.visible}
        >
          {state.visible && modalObj[state.type]?.component}
        </SDrawerOrModal>
        {openExtraConfigModal && (
          <ExtraModal
            openModal={openExtraConfigModal}
            chooseType={extraConfigChooseBustype}
            editData={editExtraConfig}
            basicInfo={editExtraConfigRecord}
            setEditData={setEditExtraConfig}
            onClose={() => setOpenExtraConfigModal(false)}
          />
        )}
      </div>
    </>
  )
}

export default StepPackageProduct
